export const originStatusName = concStatus => {
  let name;
  switch (concStatus) {
    case 1:
    case "1":
      name = "Manual validada por gestor";
      break;
    case 2:
    case "2":
      name = "Prevalidada";
      break;
    case 3:
    case "3":
      name = "Automática";
      break;
    case 7:
    case "7":
      name = "Borrada";
      break;
    case 0:
    case "0":
      name = "Creación manual";
      break;
    default:
      name = "Manual";
  }
  return name;
};
export const sapStatusName = sapStatus => {
  let name;
  switch (sapStatus) {
    case 2:
      name = "Enviado";
      break;
    case 3:
      name = "OK";
      break;
    case 7:
      name = "Borrada";
      break;
    case 4:
      name = "KO";
      break;
    default:
      name = "Pendiente";
  }
  return name;
};

export default { originStatusName, sapStatusName };
